import React, {useEffect, useState,} from 'react';

function AppWebReportTaetigkeitsberichtReportEmployeeTable(props) {
    let [employeeData, setEmployeeData] = useState([]);

       useEffect(() => {
        if(props.employeeData===undefined){
            setEmployeeData([]);
        }
        else{
            setEmployeeData(props.employeeData)
        }
    }, [props.employeeData]);

    const getEmployeeTableBody = (employeeData) => {

        return employeeData?.map((item) => (<tr key={item.id}>
            <td>{item.firstName}</td>
            <td>{item.lastName}</td>
            <td>{item.role}</td>
            <td>{item.workHours.startTime.substring(0, 5) + " - "
            +item.workHours.endTime.substring(0, 5)}</td>
            <td>{item.workHours.duration}</td>
        </tr>));
    };

    return (<>
            <br/>
            <table className="table handwai-white-text">
                <thead>
                <tr>
                    <th>Vorname</th>
                    <th>Nachname</th>
                    <th>Rolle</th>
                    <th>Arbeitszeit</th>
                    <th>Stunden</th>
                </tr>
                </thead>
                <tbody>{getEmployeeTableBody(employeeData)}</tbody>
            </table>
        </>
    );
}

export default AppWebReportTaetigkeitsberichtReportEmployeeTable;
